import type { ReactNode } from 'react';

/**
 * SF-T-330: the task's top row (TaskDetailView's toolbar): `start` is what says what the task is (who it's for,
 * its status, its refs), `children` its buttons and the close cross. The buttons never shrink or leave the row;
 * when the row is too full, `start` clips at its edge and fades out there, so a cut-off pill reads as "more here".
 * The fade sits in `start`'s own right padding: only what reaches past its room fades, and a ref that shortens
 * with … (min-w-0, truncate) ends before it.
 */
export function TaskToolbarRow({ start, children }: { start: ReactNode; children?: ReactNode }) {
  return (
    <div className="flex min-w-0 items-center gap-0.5" data-task-toolbar>
      {/* -my-1 py-1 and -ml-1 pl-1: the mask's box takes in the focus rings it would otherwise hide. */}
      <div
        className="-my-1 -ml-1 flex min-w-0 flex-1 items-center overflow-x-clip py-1 pl-1 pr-2 [mask-image:linear-gradient(to_right,black_calc(100%-0.5rem),transparent)]"
        data-task-toolbar-start
      >
        {start}
      </div>
      {children}
    </div>
  );
}
